module.exports = __webpack_public_path__ + "media/components/src/assets/images/back-arrow/back-arrow-v2-ae607827cc69cc483b290834069bcbf9.svg";